import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContentContext = createContext({ content: null, refresh: () => {} });

export const imgSrc = (value) => {
  if (!value) return "";
  if (value.startsWith("http") || value.startsWith("/assets")) return value;
  return `${process.env.REACT_APP_BACKEND_URL}/api/files/${value}`;
};

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);

  const refresh = () =>
    axios
      .get(`${API}/content`)
      .then((res) => setContent(res.data.data))
      .catch(() => {});

  useEffect(() => {
    refresh();
  }, []);

  return (
    <ContentContext.Provider value={{ content, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
